import styled from 'styled-components';
import { EllipsisWithLineClamp } from '@simplywallst/ui-core';
import { CopyLinkOutline } from '@simplywallst/ui-core/icons';

interface VisibilityProps {
  /** Value of 0 to 1. 0 means completely hidden and 1 means fully visible */
  visibility: number;
}

export const SnowflakeContainer = styled('div').attrs<VisibilityProps>(
  (props) => ({
    style: {
      opacity: props.visibility,
      clipPath: `inset(${100 - props.visibility * 100}% 0 0 0)`,
    },
  })
)<VisibilityProps>`
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const LabelsContainer = styled('div').attrs<VisibilityProps>(
  (props) => ({
    style: {
      opacity: props.visibility,
    },
  })
)<VisibilityProps>`
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const SnowflakeWrapper = styled('div')<{ toggleMe?: boolean }>`
  margin: ${({ theme }) => `-18px -${theme.x1spacePx}px`};
  max-width: 160px;
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const ActionsWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx - 4}px;
`;

export const MainTitle = styled('p')`
  ${({ theme }) => theme.typography.smallStrong}
  margin: 0;
  margin-top: -10px;
  ${EllipsisWithLineClamp(1)};
`;

export const CopyIcon = styled(CopyLinkOutline)`
  fill: ${({ theme }) => theme.color.mediumGrayRGBA(0.5)};
  cursor: pointer;
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  transform: translate(0px, 6px);

  &:hover {
    fill: ${({ theme }) => theme.color.mediumGray};
  }
`;

export const Title = styled('p')`
  margin: 0;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  ${({ theme }) => theme.typography.xSmall}
`;

export const TitleLight = styled('p')`
  margin: 0;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  ${({ theme }) => theme.typography.tiny}
  margin-top: 2px;
`;
